export default function initMenuToggle() {

    const menuBtn = document.querySelector('#menu-btn');
    const closeMenuBtn = document.querySelector('#close-menu-btn');
    const menu = document.querySelector('#menu');

    menuBtn.onclick = function (e) {
        e.stopPropagation();
        menu.classList.remove('translate-x-full');
    };

    closeMenuBtn.onclick = function (e) {
        e.stopPropagation();
        menu.classList.add('translate-x-full');
    };
}
